import React, { useEffect } from 'react'
import CustomModal from 'components/CustomModal/CustomModal'
import { useHistory } from 'react-router-dom'
import ShareV2 from './ShareV2'
import { setEmbedData, setQrCodeData, setQrCodeModal } from '../../Manage/actions'
import { setShowPaymentModal, showUpgradeCardModal, UPGRADE_QR_PAYLOAD } from '../../actions'
import { PLANS } from '../../constants/plans'
import { useDispatch } from 'react-redux'

const ShareModal = ({ show, onClose, userProfile, site }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (show) {
      history.push({ pathname: '/manage/share' })
    }
  }, [show, history])

  const onQRCodeClick = () => {
    if (userProfile.productId) {
      dispatch(setQrCodeModal(true))
      dispatch(setQrCodeData(site))
    } else {
      dispatch(
        showUpgradeCardModal({
          ...UPGRADE_QR_PAYLOAD,
          onClick: () =>
            dispatch(
              setShowPaymentModal({
                showPaymentModal: true,
                upgradePlanId: PLANS.TINY.id
              })
            )
        })
      )
    }
  }

  return (
    <CustomModal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="md"
      className="success_modal"
      enforceFocus={false}
    >
      {site && (
        <ShareV2
          onClose={onClose}
          onEmbed={() => {
            dispatch(setEmbedData(true, site))
          }}
          onQRClick={() => onQRCodeClick()}
          site={site}
          userProfile={userProfile}
        />
      )}
    </CustomModal>
  )
}

export default ShareModal
